import React, { forwardRef, useMemo } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import CycodeMappingFormV2 from "./CycodeMappingFormV2";
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import CycodeMappingForm from "./CycodeMappingForm";
import CycodeCSPMMappingForm from "./CycodeCSPMMappingForm";
import { Alert } from 'antd' 

function CycodeCredentialsForm(props, ref) {
  const featureFlags = useFeatureFlag();

  const fields = useMemo(
    () => [
      {
        name: "apiEndpoint",
        label: "API Endpoint",
        rules: [urlRegexValidator],
      },
      {
        name: "clientId",
        label: "Client Id",
        required: true,
      },
      {
        name: "secret",
        label: "Secret",
        required: true,
        type: FieldTypes.PASSWORD,
      },
      {
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
      }
    ],
    []
  );

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={featureFlags.CYCODE_PULL_CLOUD_ACCOUNT_VIOLATIONS ? CycodeCSPMMappingForm : featureFlags.DISCOVERY_CYCODE_REPO_NAME_WITH_PROJECT ? CycodeMappingFormV2 : CycodeMappingForm}
      initialValue={{ apiEndpoint: "https://api.cycode.com" }}
    />
  );
}

export default forwardRef(CycodeCredentialsForm);
